// src/hooks/usePresenceStatus.js

import { useState, useEffect } from 'react';
import { rtdb } from '../config/firebase';
import { ref, onValue } from 'firebase/database';

export const usePresenceStatus = (userId) => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!userId) return;

    const userStatusRef = ref(rtdb, 'status/' + userId);
    const unsubscribe = onValue(userStatusRef, (snap) => {
      setStatus(snap.val());
    });

    return () => unsubscribe();
  }, [userId]);

  return status;
};